import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Container, Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(
                "https://motor-easy.clickbooster.io/api/login",
                { email, password },
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.data.user && response.data.user.user_type !== undefined) {
                const userType = response.data.user.user_type;
                sessionStorage.setItem("user_type", userType);
                localStorage.setItem("user_email", response.data.user.email);

                if (userType === 1) {
                    navigate("/admin/Dashboard");
                } else {
                    navigate("/");
                }

                toast.success("Login successful!");
            } else {
                toast.error("Invalid credentials. Please try again.");
            }
        } catch (error) {
            toast.error("Invalid email or password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center  justify-content-center min-vh-100">
            <Row className="w-100">
                <Col md={{ span: 6, offset: 3 }}>
                    <Card>
                        <Card.Header className="text-center bg-primary text-white">
                            <h2>Admin Login</h2>
                        </Card.Header>
                        <Card.Body>
                            <ToastContainer />
                            <Form onSubmit={handleLogin}>
                                <Form.Group controlId="formEmail" className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="formPassword" className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" disabled={loading} className="w-100">
                                    {loading ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{" "}
                                            Logging in...
                                        </>
                                    ) : (
                                        "Login"
                                    )}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminLogin;
